import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const DisclaimerPage = () => {
  return (
    <div className="min-h-screen pt-20" data-testid="disclaimer-page">
      {/* Header */}
      <section className="py-12 md:py-16 bg-[#2E5C31]">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 text-white">
          <Link to="/" className="inline-flex items-center text-white/80 hover:text-white mb-4 transition-colors">
            <ArrowLeft className="w-4 h-4 mr-2" />
            Back to Home
          </Link>
          <h1 className="text-3xl md:text-4xl font-bold font-['Poppins']">Disclaimer</h1>
          <p className="text-gray-200 mt-2">Last updated: December 2024</p>
        </div>
      </section>

      {/* Content */}
      <section className="py-12 md:py-16 bg-white">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-4xl">
          <div className="policy-content prose prose-lg">
            <h2>General Disclaimer</h2>
            <p>
              The information provided on this website and through our services is for general informational purposes only. All information is provided in good faith, however, we make no representation or warranty of any kind, express or implied, regarding the accuracy, adequacy, validity, reliability, availability, or completeness of any information.
            </p>

            <h2>Professional Services Disclaimer</h2>
            <p>
              DecorVista Landscaping Services provides landscaping services for residential properties. While we strive to deliver high-quality results:
            </p>
            <ul>
              <li>Results may vary based on property conditions, weather, and other factors</li>
              <li>Plant growth and survival depend on proper care and environmental conditions</li>
              <li>Project timelines are estimates and may be affected by weather or unforeseen circumstances</li>
              <li>Pricing varies based on project scope, materials, and property conditions</li>
            </ul>

            <h2>Website Content</h2>
            <p>
              The content on this website, including text, graphics, images, and other material, is for informational purposes only and does not constitute professional advice.
            </p>
            <ul>
              <li>Images are representative and may not reflect exact materials or results</li>
              <li>Project galleries show actual completed work but results vary by project</li>
              <li>Service descriptions are general and specific offerings may vary</li>
            </ul>

            <h2>External Links</h2>
            <p>
              Our website may contain links to external websites that are not operated by us. We have no control over the content and practices of these sites and cannot accept responsibility for their respective privacy policies.
            </p>

            <h2>Limitation of Liability</h2>
            <p>
              In no event shall DecorVista Landscaping Services, its directors, employees, partners, agents, suppliers, or affiliates be liable for any indirect, incidental, special, consequential, or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from:
            </p>
            <ul>
              <li>Your access to or use of (or inability to access or use) our services</li>
              <li>Any conduct or content of any third party</li>
              <li>Unauthorized access, use, or alteration of your information</li>
              <li>Weather-related delays or plant loss</li>
            </ul>

            <h2>No Guarantees</h2>
            <p>
              While we strive for excellence in all our projects, we do not guarantee:
            </p>
            <ul>
              <li>Specific outcomes or results</li>
              <li>Exact completion dates (estimates only)</li>
              <li>Plant survival beyond warranty periods</li>
              <li>That all landscaping will remain unchanged over time</li>
            </ul>

            <h2>Weather and Natural Conditions</h2>
            <p>
              Landscaping is subject to natural conditions beyond our control:
            </p>
            <ul>
              <li>Extreme weather can affect plant health and project timelines</li>
              <li>Soil conditions may impact plant growth</li>
              <li>Wildlife and pests can affect landscaping</li>
              <li>Natural settling and seasonal changes are normal</li>
            </ul>

            <h2>Changes to This Disclaimer</h2>
            <p>
              We reserve the right to update this disclaimer at any time. Changes will be posted on this page with an updated revision date.
            </p>

            <h2>Contact Information</h2>
            <p>If you have any questions about this Disclaimer:</p>
            <ul>
              <li><strong>Business Name:</strong> DecorVista Landscaping Services</li>
              <li><strong>Address:</strong> 667 Harbor View Drive, Seattle, WA 98101</li>
              <li><strong>Phone:</strong> +1-888-880-8889</li>
              <li><strong>Email:</strong> support@decorvista.store</li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

export default DisclaimerPage;
